import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, HStack } from '@chakra-ui/react';
import { theme } from '../../../modules/theme';
export const AccentCardFooter = forwardRef((props, ref) => {
    return (_jsx(HStack, { ref: ref, mt: { base: theme.sizes['8'], md: theme.sizes['10'] }, spacing: { base: theme.sizes['4'] }, ...props }));
});
